"use client";
import { ContactForm } from "../../../components/footer/ContactForm";

export default function Contact() {
  return <ContactForm />;
}
